import { api } from './api';

// Buffer for batching events
let eventBuffer = [];
let flushTimer = null;

export const sendReelEvent = (reelId, eventType, meta = {}) => {
  eventBuffer.push({
    reel_id: reelId,
    event_type: eventType,
    meta
  });

  // Flush after 2 seconds or when buffer reaches 10 events
  if (eventBuffer.length >= 10) {
    flushEvents();
  } else {
    if (flushTimer) clearTimeout(flushTimer);
    flushTimer = setTimeout(flushEvents, 2000);
  }
};

const flushEvents = async () => {
  if (eventBuffer.length === 0) return;

  const eventsToSend = [...eventBuffer];
  eventBuffer = [];

  try {
    await api.post('/reel-events', { events: eventsToSend });
  } catch (error) {
    console.error('Failed to send reel events:', error);
    // Don't retry to avoid memory issues
  }
};

// Flush on page unload
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    if (eventBuffer.length > 0) {
      // Use sendBeacon for reliable delivery on page unload
      const data = JSON.stringify({ events: eventBuffer });
      navigator.sendBeacon(`${process.env.REACT_APP_BACKEND_URL}/api/reel-events`, data);
      eventBuffer = [];
    }
  });
}
